import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getModels,
  getVectors,
} from "../../../services/api/instances/embeddingsApi/methods";
import type { PostObjType } from "../../../services/api/instances/embeddingsApi/types";
import { getError } from "../../../services/lib/getError";

export const getEmbeddingsModelsAction = createAsyncThunk(
  "embeddings/getEmbeddingsModels",
  async (_, { rejectWithValue }) => {
    try {
      return await getModels();
    } catch (e: unknown) {
      const message = getError(e);
      return rejectWithValue(message ?? "An unknown error occurred");
    }
  },
);

export const getEmbeddingsVectorsAction = createAsyncThunk(
  "embeddings/getEmbeddingsVectors",
  async (postObj: PostObjType, { rejectWithValue }) => {
    try {
      return await getVectors(postObj);
    } catch (e: unknown) {
      const message = getError(e);
      return rejectWithValue(message ?? "An unknown error occurred");
    }
  },
);
